import axios from '../base/axios';
import API_KEY from './key';

const GET_CRIME = 'flixfrenzy/redux/GET_CRIME';

// eslint-disable-next-line default-param-last
const crimeReducer = (state = [], action) => {
  switch (action.type) {
    case GET_CRIME:
      return action.payload;
    default:
      return state;
  }
};

export const getCrime = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=80`).then((res) => {
    dispatch({
      type: GET_CRIME,
      payload: res.data,
    });
  });
};

export default crimeReducer;
